import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41a606cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "row bg-white-50 p-4 mb-4 rounded-4 align-items-center" }
const _hoisted_3 = { class: "w-100 row mb-4 pb-4 border-bottom" }
const _hoisted_4 = { class: "col-lg-2 col-form-label field-label" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = ["placeholder", "onKeyup", "maxlength"]
const _hoisted_8 = { class: "w-100 row mb-4 pb-4 border-bottom" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 col-form-label field-label" }, null, -1))
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "position-relative" }
const _hoisted_12 = { class: "form-check" }
const _hoisted_13 = {
  class: "form-check-label fs-7",
  for: "cbSearchPublic"
}
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = {
  class: "form-check-label fs-7",
  for: "cbSearchPrivate"
}
const _hoisted_16 = { class: "w-100 row mb-4 pb-4 border-bottom" }
const _hoisted_17 = { class: "col-lg-2 col-form-label field-label" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "position-relative" }
const _hoisted_20 = ["placeholder", "onKeyup", "maxlength"]
const _hoisted_21 = { class: "d-flex align-items-center justify-content-center" }

import { translate } from '@/languages/i18n'
import { MAX_LENGTH_TITLE_SEARCH } from '@/constants/number'
import { ref } from 'vue'
import {
  ARTICLE_CONTENT_FIELD_NAME,
  ARTICLE_PUBLISH_STATUS_FIELD_NAME,
  ARTICLE_SEARCH_PRIVATE_FIELD_NAME,
  ARTICLE_SEARCH_PUBLIC_FIELD_NAME,
  ARTICLE_TITLE_FIELD_NAME,
  CONTENT_SEARCH_MAX_LENGTH,
  PUBLISH_STATUS_NONE,
  ARTICLE_SEARCH_PUBLISH_STATUS_PRIVATE_VALUE,
  ARTICLE_SEARCH_PUBLISH_STATUS_PUBLIC_VALUE,
  URL_QUERY,
} from '@/views/community-admin/community-site/constants'
import Button from '@/components/button/index.vue'
import { useRoute, useRouter } from 'vue-router'
import _, { omit, pick } from 'lodash'
import { onMounted, watch } from 'vue-demi'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const formData = ref({
  [ARTICLE_TITLE_FIELD_NAME]: '',
  [ARTICLE_CONTENT_FIELD_NAME]: '',
  [ARTICLE_SEARCH_PUBLIC_FIELD_NAME]: true,
  [ARTICLE_SEARCH_PRIVATE_FIELD_NAME]: true,
})

onMounted(() => {
  updateFormByUrlQuery()
})

watch(
  () => route.query,
  () => {
    if (route.meta.screenId === 'CK10') {
      updateFormByUrlQuery()
    }
  }
)

const updateFormByUrlQuery = () => {
  const publishedStatus = route.query[URL_QUERY.PUBLISHED] ?? ''
  if (publishedStatus && ![ARTICLE_SEARCH_PUBLISH_STATUS_PUBLIC_VALUE, ARTICLE_SEARCH_PUBLISH_STATUS_PRIVATE_VALUE, PUBLISH_STATUS_NONE].includes(publishedStatus)) {
    router.replace({ path: route.path, query: omit(route.query, URL_QUERY.PUBLISHED) })
  }
  formData.value = {
    [ARTICLE_TITLE_FIELD_NAME]: route.query[URL_QUERY.TITLE]?.toString() ?? '',
    [ARTICLE_CONTENT_FIELD_NAME]: route.query[URL_QUERY.CONTENT]?.toString() ?? '',
    [ARTICLE_SEARCH_PUBLIC_FIELD_NAME]: !publishedStatus || publishedStatus === ARTICLE_SEARCH_PUBLISH_STATUS_PUBLIC_VALUE,
    [ARTICLE_SEARCH_PRIVATE_FIELD_NAME]: !publishedStatus || publishedStatus === ARTICLE_SEARCH_PUBLISH_STATUS_PRIVATE_VALUE,
  }
}
const handleSearch = () => {
  const includePublic = formData.value[ARTICLE_SEARCH_PUBLIC_FIELD_NAME]
  const includePrivate = formData.value[ARTICLE_SEARCH_PRIVATE_FIELD_NAME]
  const query = {
    ...omit(route.query, ARTICLE_PUBLISH_STATUS_FIELD_NAME),
    ...pick(formData.value, ARTICLE_TITLE_FIELD_NAME, ARTICLE_CONTENT_FIELD_NAME),
  }
  if (!includePublic && !includePrivate) {
    query[ARTICLE_PUBLISH_STATUS_FIELD_NAME] = PUBLISH_STATUS_NONE
  } else if (includePublic && !includePrivate) {
    query[ARTICLE_PUBLISH_STATUS_FIELD_NAME] = ARTICLE_SEARCH_PUBLISH_STATUS_PUBLIC_VALUE
  } else if (!includePublic && includePrivate) {
    query[ARTICLE_PUBLISH_STATUS_FIELD_NAME] = ARTICLE_SEARCH_PUBLISH_STATUS_PRIVATE_VALUE
  }
  query[URL_QUERY.PAGE_NUMBER] = 1
  if (_.isEqual(query, route.query)) {
    query[URL_QUERY.REFRESH] = 1
  }
  router.replace({ path: route.path, query })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSearch, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)('title')), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control w-100 position-absolute",
              type: "text",
              placeholder: _unref(translate)('placeholder'),
              onKeyup: _withKeys(($event: any) => ('submit'), ["enter"]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value[_unref(ARTICLE_TITLE_FIELD_NAME)]) = $event)),
              maxlength: _unref(MAX_LENGTH_TITLE_SEARCH)
            }, null, 40, _hoisted_7), [
              [
                _vModelText,
                formData.value[_unref(ARTICLE_TITLE_FIELD_NAME)],
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "cbSearchPublic",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value[_unref(ARTICLE_SEARCH_PUBLIC_FIELD_NAME)]) = $event))
                }, null, 512), [
                  [_vModelCheckbox, formData.value[_unref(ARTICLE_SEARCH_PUBLIC_FIELD_NAME)]]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(translate)('CK10PublicStatus')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "cbSearchPrivate",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value[_unref(ARTICLE_SEARCH_PRIVATE_FIELD_NAME)]) = $event))
                }, null, 512), [
                  [_vModelCheckbox, formData.value[_unref(ARTICLE_SEARCH_PRIVATE_FIELD_NAME)]]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(translate)('CK10PrivateStatus')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(translate)('content')), 1),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control w-100 position-absolute",
              type: "text",
              placeholder: _unref(translate)('placeholder'),
              onKeyup: _withKeys(($event: any) => ('submit'), ["enter"]),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value[_unref(ARTICLE_CONTENT_FIELD_NAME)]) = $event)),
              maxlength: _unref(CONTENT_SEARCH_MAX_LENGTH)
            }, null, 40, _hoisted_20), [
              [
                _vModelText,
                formData.value[_unref(ARTICLE_CONTENT_FIELD_NAME)],
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(Button, {
          title: _unref(translate)('CI10search'),
          type: 'secondary',
          htmlType: 'submit'
        }, null, 8, ["title"])
      ])
    ])
  ], 40, _hoisted_1))
}
}

})